export default __webpack_public_path__ + "static/media/guitar.f91bea88.svg";